import React, { useState, useEffect } from 'react';
import { getCardGradient, getCategoryGlyph } from '../pages/articles.utils';
import './ArticleCover.css';

/**
 * Visuel de couverture d'un article (hero de la page article, carte de la grille
 * blog, carte « article similaire »).
 *
 * Si l'article porte une `image_url`, on affiche l'image en `object-fit: cover`.
 * Sinon — ou si l'image ne se charge pas — on retombe sur un dégradé déterministe
 * (dérivé de l'id) surmonté du pictogramme de la catégorie, ce qui évite les
 * blocs de couleur vides quand la rédaction n'a pas encore de visuel.
 *
 * `children` est superposé à l'image (badge de catégorie positionné en absolu).
 */
const ArticleCover = ({
  id,
  imageUrl,
  titre = '',
  category,
  className = '',
  glyphSize = 'md',
  eager = false,
  children,
}) => {
  const [failed, setFailed] = useState(false);

  // Un même composant peut être réutilisé pour un autre article (navigation
  // entre articles similaires) : on réarme le fallback quand l'URL change.
  useEffect(() => { setFailed(false); }, [imageUrl]);

  const showImage = Boolean(imageUrl) && !failed;

  return (
    <div
      className={`article-cover ${className}`}
      style={{ background: getCardGradient(id) }}
    >
      {showImage ? (
        <img
          className="article-cover__img"
          src={imageUrl}
          alt={titre}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <span
          className={`article-cover__glyph article-cover__glyph--${glyphSize}`}
          aria-hidden="true"
        >
          {getCategoryGlyph(category)}
        </span>
      )}
      {children}
    </div>
  );
};

export default ArticleCover;
